/** The API's 409 code for a programme without a licence class: it has no record or signature (PD-0023). */
export const RECORD_NOT_AVAILABLE = "training-record-not-available";
